import asyncActionType from "../../utils/asyncActionType";

export const FETCH_INVENTORIES = asyncActionType("FETCH_INVENTORIES");

export const FETCH_INVENTORIED_ITEMS = asyncActionType("FETCH_INVENTORIED_ITEMS");
export const FETCH_INVENTORIED_ITEMS_CSV = asyncActionType("FETCH_INVENTORIED_ITEMS_CSV");

export const FETCH_SHIPMENT_REPORT = asyncActionType("FETCH_SHIPMENT_REPORT");

export const FETCH_INVOICE_REPORT = asyncActionType("FETCH_INVOICE_REPORT");
export const FETCH_INVOICE_REPORT_CSV = asyncActionType("FETCH_INVOICE_REPORT_CSV");

export const FETCH_PRODUCTION_REPORT = asyncActionType("FETCH_PRODUCTION_REPORT");

export const FETCH_INVENTORY_WASTE_REPORT = asyncActionType("FETCH_INVENTORY_WASTE_REPORT");
export const FETCH_INVENTORY_WASTE_REPORT_CSV = asyncActionType("FETCH_INVENTORY_WASTE_REPORT_CSV");

export const FETCH_YIELD_REPORT = asyncActionType("FETCH_YIELD_REPORT");
export const FETCH_YIELD_REPORT_CSV = asyncActionType("FETCH_YIELD_REPORT_CSV");
export const FETCH_AVERAGE_YIELD = asyncActionType("FETCH_AVERAGE_YIELD");

export const FETCH_EXPIRED_INVENTORIES_REPORT = asyncActionType("FETCH_EXPIRED_INVENTORIES_REPORT");
export const FETCH_EXPIRED_INVENTORIES_REPORT_CSV = asyncActionType("FETCH_EXPIRED_INVENTORIES_REPORT_CSV");

export const FETCH_WEIGHTED_PRICE_REPORT = asyncActionType("FETCH_WEIGHTED_PRICE_REPORT");
export const FETCH_WEIGHTED_PRICE_REPORT_CSV = asyncActionType("FETCH_WEIGHTED_PRICE_REPORT_CSV");

export const FETCH_RECEIVING_REPORT = asyncActionType("FETCH_RECEIVING_REPORT");
